import { FC, ReactElement } from 'react';

import { LinkButton, SafeHtml } from '../../../../../components';
import { TextCarouselSlideInterface } from '../../../../../entities/@sections/TextCarousel/TextCarousel';

import './TextCarouselSlide.scss';

export interface TextCarouselSlideProps extends TextCarouselSlideInterface {
    className?: string;
}

const TextCarouselSlide: FC<TextCarouselSlideProps> = ({
    title,
    paragraphHtml,
    link,
    className = '',
}): ReactElement => (
    <li className={`text-carousel-slide ${className}`}>
        <h3 className="text-carousel-slide__title">
            {title}
        </h3>

        {paragraphHtml && (
            <SafeHtml
                html={paragraphHtml}
                className="text-carousel-slide__description"
            />
        )}

        {link && (
            <LinkButton
                to={link.path}
                text={link.label}
                className="text-carousel-slide__link"
            />
        )}
    </li>
);

export default TextCarouselSlide;
